<template>
    <v-card class="mt-0 transparent">
      <v-card-text class="px-0 py-0">
        <v-tooltip left>
          <v-btn
            fixed
            dark
            bottom
            right
            fab
            class="mt-5 mr-2"
            :to="{ name: 'RecipientNew' }"
            slot="activator"
            color="accent"><v-icon>add</v-icon>
          </v-btn>
          <span>Criar um novo envio</span>
        </v-tooltip>
        <v-card-title class="pt-0">
          <h2 class="main-title">Destinatários</h2>

          <v-spacer></v-spacer>

          <v-flex xs12 sm3 v-if="stateList.length > 0">
            <v-select class="select-state pr-4 reset-padding-xs"
                      v-model="pagination.state"
                      item-value="value"
                      item-text="label"
                      label="Filtrar por status"
                      :hide-details="true"
                      :items="stateList"
                      @input="filter"
                      single-line />
          </v-flex>

          <v-flex xs12 sm5 md3>
            <v-text-field v-model="search"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details />
          </v-flex>
        </v-card-title>
        <v-data-table class="table-transparent table-sticky table-clicked"
                      :headers="headers"
                      :items="recipients"
                      :search="search"
                      :rows-per-page-items="[13, 50, 100, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value':-1}]">
          <template v-slot:items="props">
            <tr :class="{'table--selected': recipientId === props.item.id}" @click="selectList(props.item.id)">
              <td class="checked-action" tabindex="0" @keydown.enter="selectList(props.item.id)">
                <v-icon class="v-align-center mr-2" size="20px" v-if="recipientId === props.item.id">radio_button_checked</v-icon>
                <v-icon class="v-align-center mr-2" size="20px" v-else>radio_button_unchecked</v-icon>
              </td>
              <td class="">{{ props.item.type }}</td>
              <td class="">{{ props.item.name }}</td>
              <td class="">{{ props.item.address.city }}</td>
              <td class="">{{ props.item.address.uf }}</td>
              <td class="">{{ props.item.address.zipCode }}</td>
              <td class="">{{ props.item.notification }}</td>
              <td class="">{{ $t(props.item.state) }} </td>
              <td class="">{{ $d(props.item.insertedAt.toDate(), 'long') }}</td>
            </tr>
          </template>
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>

      </v-card-text>
    </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'RecipientList',
    data () {
      return {
        search: '',
        recipientId: '',
        headers: [
          { text: '', value: 'checked', class: 'checked-action', sortable: false },
          { text: 'Tipo', value: 'type' },
          { text: 'Empresa', value: 'name' },
          { text: 'Cidade', value: 'city' },
          { text: 'Estado', value: 'uf' },
          { text: 'CEP', value: 'zipCode', width: '150px' },
          { text: 'Notificação', value: 'notification' },
          { text: 'Status', value: 'state' },
          { text: 'Criado em', value: 'insertedAt' }
        ],
        stateList: [
          { label: 'Todos', value: '' },
          { label: 'Processados', value: 'processed' },
          { label: 'Entregues', value: 'delivered' },
          { label: 'Falha', value: 'failed' }
        ],
        pagination: { state: '' }
      }
    },
    computed: {
      ...mapGetters({
        recipients: 'recipients/list'
      })
    },
    methods: {
      selectList (id) {
        this.recipientId = id
        this.$router.push({ name: 'RecipientShowInfo', params: { recipientId: id } })
      },
      resetRecipientId () {
        this.recipientId = null
      },
      setRecipientId () {
        this.recipientId = this.$route.params.recipientId
      },
      changeRouter () {
        this.$route.name === 'RecipientIndex' ? this.resetRecipientId() : this.setRecipientId()
      },
      filter () {
        this.$store.dispatch('recipients/getList', this.pagination.state)
      }
    },
    watch: {
      '$route': 'changeRouter'
    },
    beforeMount () {
      this.$store.dispatch('recipients/getList')
    },
    mounted () {
      this.setRecipientId()
    }
  }
</script>
